<template>
    <div
        class="vs-date-picker"
        :class="{
            'vs-date-picker--danger': danger,
            'vs-date-picker--hasValue': value,
            'vs-date-picker--disabled': disabled,
            'vs-date-picker--required': required
        }"
    >
        <label
            :for="randomId"
            class="vs-date-picker__label"
            v-if="label"
            >{{ label }}</label
        >

        <flat-pickr
            v-model="value"
            @change="onChange"
            :config="configOptions"
            class="w-full vs-date-picker__date"
            :disabled="disabled"
            :id="randomId"
            v-bind="$props"
        />
        <label
            :for="randomId"
            class="vs-date-picker__label-placeholder"
            v-if="labelPlaceholder"
            >{{ labelPlaceholder }}</label
        >
        <span
            v-if="danger"
            class="vs-date-picker__error text-danger text-sm"
            style=""
            >{{ dangerText }}</span
        >
    </div>
</template>

<script>
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
import { English } from "flatpickr/dist/l10n/default.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment';

export default {
    name: "vs-date-picker",

    components: {
        flatPickr,
    },

    props: {
        defaultValue: String,
        disabled: Boolean,
        label: String,
        'label-placeholder': String,
        danger: Boolean,
        "danger-text": String,
        required: Boolean,
        isMinMaxDate: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        value() {
            this.$emit("input", this.value);
            this.$emit("change", this.value)
        },

        defaultValue() {
            this.value = this.defaultValue;
        }
    },

    computed: {
        randomId() {
            return Math.random() * 100;
        },
    },

    data() {
        return {
            value: this.defaultValue,
            configOptions: { 
                dateFormat: 'd/m/Y'
            }
        };
    },

    created() {
        if (this.isMinMaxDate) {
            this.setMinMaxDate();
        }                    
        this.setLanguageDatePicker();
    },

    methods: {
        onChange() {
            this.$emit("change");
        },

        setLanguageDatePicker() {            
            flatpickr.localize(this.$i18n.locale === 'vi' ? Vietnamese : English);
        },

        setMinMaxDate() {
            let maxDate = new Date();
            let minDate = moment().subtract(1, 'month').startOf('month')._d;
            this.configOptions.minDate = minDate;
            this.configOptions.maxDate = maxDate;
        }
    },

    mounted() {
        this.$root.$on('updateI18n', () => {            
            this.setLanguageDatePicker();
        });
    }
};
</script>

<style lang="scss">
@import "@sass/vuexy/_variables.scss";

$grey: #babfc7;

.vs-date-picker {
    position: relative;

    .vs-date-picker__label-placeholder {
        margin-bottom: 4px;
        display: inline-block;
        // position: absolute;
        // top: 10px;
        // left: 15px;

        font-size: 14px !important;
        color: var(--vs-hex-darkblue);
        font-weight: 500;
        transition: all 150ms linear;
    }

    .vs-date-picker__label {
        color: var(--vs-hex-darkblue);
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        padding-left: 0;
        margin-bottom: 6px;
        display: inline-block;
        line-height: 1;
    }

    .vs-date-picker__date {
        & + .vs-date-picker__label-placeholder {
            font-size: 12px !important;
            top: -24px;
            left: 0;
            color: var(--vs-hex-darkblue);
            font-weight: 700;
        }

        &[required] {
            & + .vs-date-picker__label-placeholder {
                &::after {
                    content: "*";
                    color: var(--vs-hex-danger);
                    margin-left: 4px;
                }
            }
        }

        // Material Style
        // &.active + .vs-date-picker__label-placeholder {
        //     font-size: 12px !important;
        //     top: -24px;
        //     left: 0;
        //     color: var(--vs-hex-darkblue);
        //     font-weight: 700;
        // }

        // &:focus {
        //     + .vs-date-picker__label-placeholder {
        //         font-size: 12px !important;
        //         top: -24px;
        //         left: 0;
        //         color: var(--vs-hex-primary);
        //         font-weight: 700;
        //     }
        // }
    }

    // Modify : When component have an error
    &.vs-date-picker--danger {
        .vs-date-picker__label-placeholder,
        .vs-date-picker__label {
            color: var(--vs-hex-danger) !important;
        }

        .vs-date-picker__date {
            border: 1px solid var(--vs-hex-danger);
        }

        .vs-date-picker__error {
            padding: 2px 4px;
            display: block;
        }
    }

    // Modify :  When component has value in v-mode
    &.vs-date-picker--hasValue {
        .vs-date-picker__label-placeholder {
            font-size: 12px !important;
            top: -24px;
            left: 0;
            color: var(--vs-hex-darkblue);
            font-weight: 700;
        }
    }

    // Modify : When component has disabled props
    &.vs-date-picker--disabled {
        opacity: 0.4;
    }

    &.vs-date-picker--required {
        .vs-date-picker__label {
            &::after {
                content: "*";
                color: var(--vs-hex-danger);
                margin-left: 4px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/VsDatePicker.vue